module.exports = __webpack_public_path__ + "img/landing-page.d87ac2af.png";